import { render } from "./viewpurchaseorder.vue?vue&type=template&id=02f27560&scoped=true"
import script from "./viewpurchaseorder.vue?vue&type=script&lang=js"
export * from "./viewpurchaseorder.vue?vue&type=script&lang=js"

import "./viewpurchaseorder.vue?vue&type=style&index=0&id=02f27560&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f27560"]])

export default __exports__